import { useState } from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      className='footer bg-light p-2 '
      style={{ borderTop: "0.1rem solid #e5e5e5" }}
    >
      <div className='container-fluid'>
        <div className='d-flex flex-column flex-md-row justify-content-center align-items-center'>
          <div className='fs-6'>
            <a
              href='https://www.linkedin.com/company/spectra-plasmonics/'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-linkedin mx-1 text-muted'></i>
            </a>
            <a
              href='https://www.instagram.com/spectra_plasmonics?igsh=NGplZ2JnM2cyeXEy'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-instagram mx-1 text-muted'></i>
            </a>
            <a
              href='https://x.com/@SPlasmonics'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-twitter-x mx-1 text-muted'></i>
            </a>
            <a
              href='mailto:info@spectraplasmonics.com'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-envelope mx-1 text-muted'></i>
            </a>
            <a
              href='https://www.spectraplasmonics.com/'
              target='_blank'
              rel='noreferrer'
            >
              <i className='bi bi-globe2 mx-1 text-muted'></i>
            </a>
          </div>

          <div className='d-flex flex-column justify-content-center align-items-center mt-2 mt-md-0 ms-md-auto text-center text-md-end'>
            <div className='small text-muted '>
              Copyright © - 2025 Spectra Plasmonics Inc.
            </div>
            <Link to='/terms-and-conditions' className='small text-muted'>
              Terms and Conditions
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
